import { render, staticRenderFns } from "./ABuscarDocentes.vue?vue&type=template&id=f1c99ee2"
import script from "./ABuscarDocentes.vue?vue&type=script&lang=js"
export * from "./ABuscarDocentes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports